import { useMemo } from "react";
import { createContext, useReducer } from "react";

export const IdentifiedSpeciesFiltersContext = createContext();
export const IdentifiedSpeciesFiltersDispatchContext = createContext();

const initialState = {
    filterDialogOpen: false,
    visibleSpeciesCt: 5,
    showAST: true,
    showKIDCalls: true,
    showRnDModels: false,
    showImputedCalls: false,
    showResistanceGenes: false,
    showMLST: true,
    showSecondaryMetrics: true,
    loadingResistanceGenes: true,
    loadingImputations: true,
    forceShowIAndRCalls: false,
  };

const filtersReducer = (state, action) => {
    switch (action.type) {
        case 'SET_FILTER_DIALOG_OPEN':
            return {...state, filterDialogOpen: action.payload};
        case 'SET_VISIBLE_SPECIES_CT':
            return {...state, visibleSpeciesCt: action.payload};
        case 'SET_SHOW_AST':
            return {...state, showAST: action.payload};
        case 'SET_SHOW_KID_CALLS':
            return {...state, showKIDCalls: action.payload};
        case 'SET_SHOW_RND_MODELS':
            return {...state, showRnDModels: action.payload};
        case 'SET_SHOW_IMPUTED_CALLS':
            return {...state, showImputedCalls: action.payload};
        case 'SET_SHOW_RESISTANCE_GENES':
            return {...state, showResistanceGenes: action.payload};
        case 'SET_SHOW_MLST':
            return {...state, showMLST: action.payload};
        case 'SET_SHOW_SECONDARY_METRICS':
            return {...state, showSecondaryMetrics: action.payload};
        case 'SET_LOADING_RESISTANCE_GENES':
            return {...state, loadingResistanceGenes: action.payload};
        case 'SET_LOADING_IMPUTATIONS':
            return {...state, loadingImputations: action.payload};
        case 'SET_FORCE_SHOW_I_AND_R_CALLS':
            return {...state, forceShowIAndRCalls: action.payload};
        default:
            return state;
    }
}

export const IdentifiedSpeciesFiltersProvider = ({ children }) => {
    const [state, dispatch] = useReducer(filtersReducer, initialState);

    // Memoize the dispatch functions to avoid unnecessary re-renders (dispatch never changes)
    const dispatchFuncs = useMemo(() => ({
        setFilterDialogOpen: (open) => dispatch({ type: 'SET_FILTER_DIALOG_OPEN', payload: open }),
        setVisibleSpeciesCt: (count) => dispatch({ type: 'SET_VISIBLE_SPECIES_CT', payload: count }),
        setShowAST: (show) => dispatch({ type: 'SET_SHOW_AST', payload: show }),
        setShowKIDCalls: (show) => dispatch({ type: 'SET_SHOW_KID_CALLS', payload: show }),
        setShowRnDModels: (show) => dispatch({ type: 'SET_SHOW_RND_MODELS', payload: show }),
        setShowImputedCalls: (show) => dispatch({ type: 'SET_SHOW_IMPUTED_CALLS', payload: show }),
        setShowResistanceGenes: (show) => dispatch({ type: 'SET_SHOW_RESISTANCE_GENES', payload: show }),
        setShowMLST: (show) => dispatch({ type: 'SET_SHOW_MLST', payload: show }),
        setShowSecondaryMetrics: (show) => dispatch({ type: 'SET_SHOW_SECONDARY_METRICS', payload: show }),
        setLoadingResistanceGenes: (loading) => dispatch({ type: 'SET_LOADING_RESISTANCE_GENES', payload: loading }),
        setLoadingImputations: (loading) => dispatch({ type: 'SET_LOADING_IMPUTATIONS', payload: loading }),
        setForceShowIAndRCalls: (show) => dispatch({ type: 'SET_FORCE_SHOW_I_AND_R_CALLS', payload: show }),
    }), [dispatch]);

    return (
        <IdentifiedSpeciesFiltersContext.Provider value={state}>
            <IdentifiedSpeciesFiltersDispatchContext.Provider value={dispatchFuncs}>
                {children}
            </IdentifiedSpeciesFiltersDispatchContext.Provider>
        </IdentifiedSpeciesFiltersContext.Provider>
    );
}